/* Evidence-based filtering shared by the storefront and regression checks. */
(function (root, factory) {
  var engine = factory();
  if (typeof module === 'object' && module.exports) module.exports = engine;
  if (root) root.StreetRidesFinderEngine = engine;
}(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var privateTypes = ['dirt', 'atv', 'go-kart', 'snow', 'utility', 'kids'];
  var labels = { ebike: 'E-bike', scooter: 'Stand-up scooter', 'seated-scooter': 'Seated electric scooter', board: 'Electric board', trike: 'Electric tricycle', cargo: 'Cargo e-bike', moped: 'Motorcycle-style e-bike or moped', mobility: 'Mobility scooter', dirt: 'Electric dirt bike', atv: 'Electric ATV', 'go-kart': 'Electric go-kart', snow: 'Snow vehicle', utility: 'Utility vehicle', kids: 'Children’s ride', accessories: 'Accessory' };
  function has(preferences, key) { return preferences.indexOf(key) !== -1; }
  function budgetAllows(price, preferences) {
    if (!Number.isFinite(price) || price <= 0) return false;
    if (has(preferences, 'budget-under-1000')) return price < 100000;
    if (has(preferences, 'budget-1000-2500')) return price <= 250000;
    if (has(preferences, 'budget-2500-5000')) return price <= 500000;
    return true;
  }
  function purchasableVariant(product, preferences) {
    return (product.variants || []).filter(function (variant) {
      var variantTitle = String(variant.title || '');
      var incompleteRide = product.vehicleType !== 'accessories' &&
        /\b(?:battery\s+not\s+included|without\s+(?:a\s+)?battery|no\s+battery|batteryless|frame\s+only)\b/i.test(variantTitle);
      var choiceUnconfirmed = /\bconfirm\s+after\s+order\b/i.test(variantTitle);
      return variant.available === true && variant.inventoryTracked === true &&
        Number(variant.inventoryQuantity) > 0 && !incompleteRide && !choiceUnconfirmed && budgetAllows(Number(variant.priceCents), preferences);
    }).sort(function (a, b) { return Number(a.priceCents) - Number(b.priceCents); })[0] || null;
  }
  function evaluate(product, options) {
    options = options || {};
    var preferences = options.preferences || [];
    var features = product.features || {};
    var selectedTypes = options.allowedVehicleTypes || (options.vehicleType ? [options.vehicleType] : []);
    if (product.direct !== true || product.excluded === true) return { rejected: 'unavailable-source' };
    if (!labels[product.vehicleType]) return { rejected: 'unverified-vehicle-type' };
    if (selectedTypes.length && selectedTypes.indexOf(product.vehicleType) === -1) return { rejected: 'vehicle-type' };
    var childRider = options.riderType === 'child' || has(preferences, 'kids');
    if (childRider && product.vehicleType !== 'kids') return { rejected: 'child-fit-unconfirmed' };
    if (!childRider && product.vehicleType === 'kids') return { rejected: 'child-only-vehicle' };
    if (product.vehicleType === 'accessories') return { rejected: 'accessory' };
    if (has(preferences, 'public') && privateTypes.indexOf(product.vehicleType) !== -1) return { rejected: 'private-use-vehicle' };
    if (has(preferences, 'must-fold') && features.folding !== true) return { rejected: 'folding-unconfirmed' };
    if (has(preferences, 'must-step-through') && features.stepThrough !== true) return { rejected: 'step-through-unconfirmed' };
    var variant = purchasableVariant(product, preferences);
    if (!variant) return { rejected: 'stock-or-budget' };
    var scores = options.categoryScores || {};
    var score = Math.max.apply(Math, [0].concat((product.categories || []).map(function (category) { return Number(scores[category]) || 0; })));
    var reasons = [labels[product.vehicleType], 'In stock'];
    if (has(preferences, 'must-fold')) reasons.push('Listed as folding');
    else if (features.folding === true) reasons.push('Folding frame');
    if (has(preferences, 'must-step-through')) reasons.push('Listed with a step-through frame');
    else if (features.stepThrough === true) reasons.push('Step-through frame');
    if (has(preferences, 'compact-footprint') && features.compact === true) { score += 4; reasons.push('Compact design identified'); }
    if (has(preferences, 'easy-mount') && features.stepThrough === true) { score += 2; reasons.push('Step-through frame'); }
    var checks = [];
    if (has(preferences, 'lift')) checks.push('Confirm the assembled carrying weight, including the battery');
    if (has(preferences, 'compact-footprint')) checks.push('Confirm stored dimensions and carrying weight');
    if (has(preferences, 'hills')) checks.push('Confirm suitability for your hill gradients and rider weight');
    if (has(preferences, 'rough') || has(preferences, 'offroad')) checks.push('Confirm suitability for the surface and conditions of your route');
    if (has(preferences, 'snow') || has(preferences, 'weather')) checks.push('Confirm cold-weather limits and suitability for snow or slippery surfaces');
    if (childRider) checks.push('Confirm the minimum rider age, height and supervision requirements');
    if (has(preferences, 'short') || has(preferences, 'medium') || has(preferences, 'long')) checks.push('Confirm range for your route, rider weight and conditions');
    if (has(preferences, 'payload') || has(preferences, 'cargo')) checks.push('Confirm the rider and cargo weight limit');
    if (has(preferences, 'public') || has(preferences, 'legal-check') || has(preferences, 'legal-unknown')) checks.push('Confirm local riding rules and the exact model configuration');
    checks.push('Confirm rider height, reach and frame fit');
    return { product: product, variant: variant, priceCents: Number(variant.priceCents), score: score, reasons: reasons, checks: checks };
  }
  function recommend(products, options) {
    options = options || {};
    var seen = Object.create(null), matches = [], excluded = {};
    (products || []).forEach(function (product) {
      var key = String(product.id || product.handle || '');
      if (!key || seen[key]) return;
      seen[key] = true;
      var result = evaluate(product, options);
      if (result.rejected) excluded[result.rejected] = (excluded[result.rejected] || 0) + 1;
      else matches.push(result);
    });
    matches.sort(function (a, b) { return b.score - a.score || a.priceCents - b.priceCents || String(a.product.title).localeCompare(String(b.product.title)); });
    var total = matches.length;
    var limit = typeof options.limit === 'number' ? Math.max(0, options.limit) : 4;
    var shortlist = matches.slice(0, limit);
    if (options.vehicleType === 'ebike' && has(options.preferences || [], 'commute') &&
        has(options.preferences || [], 'storage-open') && limit > 2) {
      var chosen = [], deferred = [], foldingShown = 0;
      matches.forEach(function (match) {
        var folding = match.product.features && match.product.features.folding === true;
        if (chosen.length >= limit) return;
        if (folding && foldingShown >= 2) { deferred.push(match); return; }
        chosen.push(match);
        if (folding) foldingShown += 1;
      });
      deferred.forEach(function (match) { if (chosen.length < limit) chosen.push(match); });
      shortlist = chosen;
    }
    return { matches: shortlist, total: total, excluded: excluded };
  }
  return { recommend: recommend, evaluate: evaluate, purchasableVariant: purchasableVariant, budgetAllows: budgetAllows };
}));
